var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-order-mark"},[_c('mark',{class:['mark', _vm.isDark ? 'dark' : 'light']},[_vm._v("\n    "+_vm._s(_vm.textMark)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }